"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEnterOrSpace = exports.default = isEnterOrSpace;
function isEnterOrSpace(event) {
  return event && (event.keyCode === 13 || event.keyCode === 32);
}